import React from 'react';
import { Button } from '@/components/ui/button';

const LabServiceSelect = ({ containsService, onRegister }) => {
  return (
    <div className="bg-[#ffffff] rounded-2xl p-0 md:p-5 select-none flex flex-col items-center h-full min-h-[500px] mt-3">
      <p className="text-center text-[#1F4B81] text-lg md:text-xl font-semibold mb-3">
        {containsService
          ? 'Paslauga jau pridėta į krepšelį'
          : 'Pridėti šią papildomą paslaugą į krepšelį'}
      </p>
      <Button
        className="px-6 py-2 font-medium rounded-4xl transition"
        variant={containsService ? 'outline':'default' }
        onClick={onRegister}
      >
        {containsService ? 'Panaikinti' : 'Pridėti'}
      </Button>
    </div>
  );
};

export default LabServiceSelect;
